
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 254","d":"M12 1.615a10.381 10.381 0 11-7.344 3.04A10.316 10.316 0 0112 1.615M12 0a12 12 0 1012 12A12 12 0 0012 0z","fill":"#3c3c3c"}})])
          )
        }
      }
    